import styled from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import CountryFlagComponent from '@prisjakt/ui-country-flag';
import { CaptionText } from '@prisjakt/ui/text/variants';
import ThumbUpIcon from 'mdi-react/ThumbUpIcon';

export const RecommendedRetailer = styled(CaptionText)`
  ${media.mediumDown`
    display: none;  
  `}
  white-space: nowrap;
`;

export const RecommendedRetailerIcon = styled(ThumbUpIcon).attrs({ size: 12 })`
  fill: ${p => p.theme.icons.secondary};
  margin-right: 0.3rem;
`;

export const HideOnMobile = styled.div`
  ${media.smallOnly`display: none;`}
`;

export const DesktopOnly = styled.div`
  ${media.mediumDown`display: none;`}
`;

export const HideOnDesktop = styled.div`
  ${media.mediumUp`display: none;`}
`;

export const CountryFlag = styled(CountryFlagComponent)`
  display: flex;
  flex: 1 0 auto;
  margin-right: ${layout.measurements.spacingTiny};
`;

export const HomeDeliveryIcon = styled.img`
  min-height: 20px;
  min-width: 20px;
  height: 20px;
  width: 20px;
  display: block;
  margin: -${layout.measurements.spacingTiny} 0;
  filter: grayscale(100%);
`;

export const Badge = styled.div`
  display: flex;
  align-items: center;
  & + & {
    margin-left: ${layout.measurements.spacingTiny};
  }
`;

export const StyledLabel = styled(CaptionText)`
  ${media.smallOnly`
      display:none;
    `}
`;

export const BadgeWrapper = styled.div``;
